import React, { use, useEffect, useState } from 'react';
import * as API from './api/api';

const timerTimeout = 120; // seconds


export default function Register() {

  const [userToken, setUserToken] = useState(localStorage.getItem('userToken'));
  const [PIN, setPIN] = useState(localStorage.getItem('session') || null);
  const[PIN2, setPIN2] = useState(null);
  const [adminToken, setAdminToken] = useState(localStorage.getItem('adminToken'));

  const [email, setEmail] = useState(localStorage.getItem('email') ||  null);
  const [firstName, setFirstName] = useState(localStorage.getItem('firstName') ||  null);
  const [lastName, setLastName] = useState(localStorage.getItem('lastName') ||  null);
  const [className, setClassName] = useState(localStorage.getItem('className') ||  null);
  const [studentId, setStudentId] = useState(localStorage.getItem('studentId') ||  null);

  const [timer, setTimer] = useState(parseInt(localStorage.getItem('timer')) || 0);

    var timerInterval = 0;

    useEffect(() => {
        if (PIN) {
            timerInterval = setInterval(() => { 
                setTimer((prevCount) => {
                    const newCount = prevCount + 1;
                    localStorage.setItem('timer', newCount);
                    return newCount;
                });
            }, 1000);
        }
        return () => {
            clearInterval(timerInterval);
        };
    } , [PIN]);

    function formatTime(seconds) {
        if(seconds === '' || isNaN(seconds) || seconds < 0) {
            return '--:--';
        }
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }


  function handleRegistration(event) {
      event.preventDefault();
      const email = document.getElementById('email').value;
      const firstName = document.getElementById('firstName').value;
      const lastName = document.getElementById('lastName').value;
      const className = document.getElementById('className').value;
      const studentId = document.getElementById('studentId').value;
      setPIN(null);
  
      API.Register(email, firstName + ' ' + lastName).then(response => {
        if(response.status){
          setFirstName(firstName);
          setLastName(lastName);
          setClassName(className);
          setStudentId(studentId);
          setEmail(email);
          localStorage.setItem('email', email);
          localStorage.setItem('userName', firstName);
          localStorage.setItem('firstName', firstName);
          localStorage.setItem('lastName', lastName);
          localStorage.setItem('className', className);
          localStorage.setItem('studentId', studentId);
  
          if(response.PIN) {
            localStorage.setItem('session', response.PIN);
            setPIN(response.PIN);
            setTimer(0);
          }
          setPIN2(response.PIN2);
        }
      });
    }
  
    function CapturePINCode(event, i) {
       const value = event.target.value;
       const charInputs = Array.from(document.querySelectorAll('.one-char-input'));
  
       if (value.length === 1 && i < charInputs.length - 1) {
            document.querySelector(`[data-index="${i + 1}"]`).focus();
        }
        // check if all inputs are filled
        const allFilled = Array.from(document.querySelectorAll('.one-char-input')).every(input => input.value.length === 1);
        if (allFilled) {
            const pin = Array.from(document.querySelectorAll('.one-char-input')).map(input => input.value).join('');
  
            API.ConfirmUser(email, firstName, lastName, className, studentId, pin).then(response => {
              if (response.userToken) {
                setUserToken(response.userToken);
                localStorage.setItem('userToken', response.userToken);
                if(response.adminToken) {
                  setAdminToken(response.adminToken);
                  localStorage.setItem('adminToken', response.adminToken);
                }
                // redirect to main app or show success message
                window.location.href = '/';
              } else {
                document.getElementById('invalidPIN').style.display = 'block';
                // Clear inputs for retry
                document.querySelectorAll('.one-char-input').forEach(input => input.value = '');
                document.querySelector(`[data-index="0"]`).focus();
              }
            });
        }
    }

    function handleCancel() {
      setPIN(null);
      localStorage.removeItem('userToken005');
      localStorage.removeItem('timer');
          localStorage.removeItem('email');
          localStorage.removeItem('userName');
          localStorage.removeItem('firstName');
          localStorage.removeItem('lastName');
          localStorage.removeItem('className');
          localStorage.removeItem('studentId');
      setTimer(0);

      window.location.href = '/';
    } 

    function DecodePIN(encodedPIN) {
      try {
        const decimalValue = parseInt(encodedPIN, 16);
        return 99999 - decimalValue; // reverse the number to get the original PIN
      } catch (error) {
        console.error('Error decoding PIN:', error);
        return null;
      }
    }

    if (userToken) {
      return null; // or a loading spinner, or redirect to the main app
    }

  return (<>
    { !firstName && (
            <div className="form-container form-container-500 white-background padding20">
                <h2>Register</h2>
                <form id="registrationForm">
                    <div className="form-group">
                        <label for="firstName">First Name</label>
                        <input type="text" id="firstName" required />
                    </div>
                    <div className="form-group">
                        <label for="lastName">Last Name</label>
                        <input type="text" id="lastName" required />
                    </div>
                    <div className="form-group">
                        <label for="className">Class Name</label>
                        <input type="text" id="className" required />
                    </div>
                    <div className="form-group">
                        <label for="studentId">Student ID</label>
                        <input type="text" id="studentId" required />
                    </div>
                    <div className="form-group">
                        <label for="email">Email</label>
                        <input type="email" id="email" required />
                    </div>
                    <button type="submit" className="btn-height45" onClick={handleRegistration}>Register</button>
                </form>
                <div className="cookie-consent">
                    By registering, you agree to our use of cookies
                </div>
            </div>
          )}

          { firstName && (
              <div className="form-container form-container-500 white-background padding20">
                <h2>Enter PIN</h2>
                <p style={{ "text-align": "center", "margin-bottom": "20px", "color": "#666" }}>
                    Enter the 5-digit code sent to <b>{email}</b> to confirm your registration.
                </p>
                <div className="otp-container" id="otpContainer">
                    {Array(5).fill(0).map((_, i) => (
                        <input key={i} type="text" className="one-char-input" maxLength="1" data-index={i} onChange={(e) => CapturePINCode(e, i)} />
                    ))}
                </div>
                <div id="countdown" >
                  <span style={{ "fontSize": "1.2em" }}>{formatTime(timer)}</span>
                  <br />
                  <button type="button" className='btn-height45' onClick={handleCancel}>Cancel</button>
                </div>
                <div id="invalidPIN" className="invalid-pin" style={{ "display": "none" }}>
                    Invalid PIN, please try again.
                </div>
                <div>
                    <p style={{ "text-align": "center", "margin-top": "20px", "color": "#666" }}>
                        Didn't receive the code? Please check your spam folder.
                    </p>
                    {PIN && timer > timerTimeout && (
                        <p style={{ "text-align": "center", "margin-top": "20px", "color": "#28a745" }}>
                            Your PIN code is: <b>{DecodePIN(PIN)}</b>.
                        </p>
                    )}
                    {PIN2 && (
                        <p style={{ "text-align": "center", "margin-top": "20px", "color": "#28a745" }}>
                            Your backup PIN code is: <b>{PIN2}</b>.
                        </p>
                    )}
                </div>
             </div>
           )}
  </>)
}